import { render, staticRenderFns } from "./ChooseGeographicalLocationReadOnlyView.vue?vue&type=template&id=2c827372&scoped=true&"
import script from "./ChooseGeographicalLocationReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ChooseGeographicalLocationReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGeographicalLocationReadOnlyView.vue?vue&type=style&index=0&id=2c827372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c827372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VLayout})
